import Component from '../core/Component'
import { format, formatCurrency, formatPercentage } from '../utils/Number'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'
const defaults = {
    large: false,
    color: "#000000",
    labels: [],
    format: 'currency' // percentage, normal, currency
}

function formatValue(value, type = '') {
    if (type === 'percentage') {
        return formatPercentage(value/100, 0)
    }

    if (type === 'currency') {
        return formatCurrency(value)
    }

    return value
}

export default class Graph extends Component {
    constructor(element) {
        super(element, defaults);

        this.lang = document.documentElement.getAttribute('lang') ? document.documentElement.getAttribute('lang') : "cs";

        this.handleResize = throttle(::this.handleResize, 100)
    }


    prepare() {
        let data = [];
        let dataset = null
        let datasets = null
        const options = this.options

        dataset = this.element.dataset.data ? JSON.parse(this.element.dataset.data) : null

        var canvas = document.createElement('canvas');
        this.element.appendChild(canvas);
        var ctx = canvas.getContext("2d");
        var maintainAspectRatio = true;

        let yAxes = [{
            ticks: {
                beginAtZero:true,
                fontColor: '#959cad',
                fontStyle: "bold",
                callback: (value, index, values) => formatValue(value, this.options.format)
            }
        }]

        if (dataset) {
            datasets = dataset
            if (datasets.filter(item => item.yAxisID).length > 1) {
                yAxes = datasets.map(dataset => ({
                    id: dataset.yAxisID,
                    ...yAxes[0],
                    position: dataset.position,
                    labelString: dataset.labelString
                }))
            }
        } else {
            datasets = [
                {
                    data: data,
                    backgroundColor: this.options.color,
                    borderColor: this.options.color,
                    borderWidth: 1
                }
            ]
        }

        this.myBar = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.options.labels,
                datasets: datasets,
            },
            options: {

                maintainAspectRatio: maintainAspectRatio,
                responsive: true,
                legend: {
                     display: false,
                },
                scales: {
                    xAxes: [{
                        barPercentage: this.options.large ? 0.8 : 0.2,
                        ticks: {
                            fontColor: '#959cad',
                            fontStyle: "bold",
                            autoSkip: false
                        },
                        gridLines: {
                            display: false,
                            drawBorder: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            fontColor: '#959cad',
                            fontStyle: "bold",
                            autoSkip: false,
                            padding: 25,
                            callback: (value, index, values) => formatValue(value, this.options.format)
                        },
                        gridLines: {
                            drawBorder: false
                        }

                    }]
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => ' ' + formatValue(tooltipItem.yLabel, this.options.format)
                    }
                  // enabled: false
                },
                animation: {
                    onComplete: () => {
                        this.resize()
                    }
                },
                plugins: {
                    datalabels: {
                        display: false
                    }
                }
            }
        });

        window.addEventListener('resize', this.handleResize)
        this.resize()

        EventBus.on('tabs:change', this.handleTabChange)
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
        EventBus.off('tabs:change', this.handleTabChange)
    }

    handleTabChange = ({ panel }) => {
        if (panel.element.contains(this.element)) {
            if (this.myBar) {
                this.myBar.update({
                    duration: 0
                })
            }
        }
    }

    handleResize = event => {
        this.resize()
    }

    resize() {
        if (this.myBar) {
            const box = this.myBar.canvas.getBoundingClientRect()
            const width = this.element.offsetWidth
            this.element.style.height = `${box.height/box.width * width}px`
        }
    }
}